<!--
 * @Author: your name
 * @Date: 2021-10-22 15:36:24
 * @LastEditTime: 2022-06-10 13:59:06
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-business\order\preempt\index.vue
-->
<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :label-width="'130px'"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      :before-reset-search="beforeResetSearch"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('PreoccupationManagement.Doc')" prop="orderNo">
            <BjInputCode v-model="queryParams.orderNo" @keyup.enter.native="handleQuery" :placeholder="$t('PreoccupationManagement.Doc')"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('PreoccupationManagement.Channel')" prop="channel">
            <BjSelectLov v-model="queryParams.channel" lov-code="SCHL.CHANNEL_TYPE" :placeholder="$t('PreoccupationManagement.Channel')"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('PreoccupationManagement.Store')" prop="storeId">
            <BjSelectStore v-model="queryParams.storeId" :placeholder="$t('PreoccupationManagement.Store')"/>
          </el-form-item>
        </el-col>
        <!-- #ifndef OPEN-SOURCE -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('PreoccupationManagement.Pre')" prop="status">
            <BjSelectLov
              v-model="queryParams.status"
              :option-list="ORDER_ADVANCE_PREEMPT_STATUS_LIST"
              :placeholder="$t('PreoccupationManagement.Pre')"
            />
          </el-form-item>
        </el-col>
        <!-- #endif -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('PreoccupationManagement.Three')">
            <BjDateTimerangePicker v-model="queryParamsTime" :placeholder="$t('PreoccupationManagement.Three')"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('PreoccupationManagement.Internal')">
            <BjDateTimerangePicker v-model="queryParamsTime_create" :placeholder="$t('PreoccupationManagement.Internal')"/>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
            :show-overflow-tooltip="col.prop !== 'bjTableAction'"
          >
            <template slot-scope="scope">
              <template v-if="false" />
              <!-- #ifndef OPEN-SOURCE -->
              <template v-else-if="col.prop === 'status'">{{
                $t(ORDER_ADVANCE_PREEMPT_STATUS_LIST.bjGet(scope.row[col.prop]))
              }}</template>
              <template v-else-if="col.prop === 'code'">
                <span class="link" @click="onDetail(scope.row)">{{ scope.row[col.prop] }}</span>
                <BjCopyIcon class="ml10" :copy="scope.row[col.prop]" />
              </template>
              <!-- //  #endif -->
              <template v-else-if="col.prop === 'outerOrderNo'">
                <span class="link" @click="$toBusinessThirdOrderView(scope.row.outerOrderNo)">{{
                  scope.row[col.prop]
                }}</span>
                <BjCopyIcon :copy="scope.row[col.prop]" />
              </template>
              <template v-else-if="col.prop === 'innerOrderNo'">
                <span class="link" @click="$toBusinessOrderInternalView(scope.row.innerOrderNo)">{{
                  scope.row[col.prop]
                }}</span>
                <BjCopyIcon :copy="scope.row[col.prop]" />
              </template>

              <template v-else-if="col.prop === 'channel'">
                {{ SCHL_CHANNEL_TYPE.bjGet(scope.row[col.prop]) }}
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { orderApi } from '@/api';
import {
  // #ifndef OPEN-SOURCE
  ORDER_ADVANCE_PREEMPT_STATUS_LIST,
  // #endif
} from '@/utils/constants';
export default {
  name: 'BusinessOrderPreempt',
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 4,
      selection: false,
      // #ifndef OPEN-SOURCE
      ORDER_ADVANCE_PREEMPT_STATUS_LIST,
      // #endif
      queryApi: orderApi.getPreemptionOrders,
      // 查询参数
      queryParamsTime: [],
      queryParamsTime_create: [],
      queryParams: {
        channel: null,
        creationDateEndTime: null,
        creationDateStartTime: null,
        orderEndTime: null,
        orderNo: null,
        orderStartTime: null,
        status: null,
        storeId: null,
      },
      labelsVersion: 11,
      labelList: [
        { label: this.$t('PreoccupationManagement.form.Third'), prop: 'outerOrderNo', isCheck: true, disabled: false, width: '190' },
        { label: this.$t('PreoccupationManagement.form.Internal'), prop: 'innerOrderNo', isCheck: true, disabled: false, width: '180' },
        // #ifndef OPEN-SOURCE
        { label: this.$t('PreoccupationManagement.form.code'), prop: 'code', isCheck: true, disabled: false, width: '140' },
        { label: this.$t('PreoccupationManagement.form.status'), prop: 'status', isCheck: true, disabled: false, width: '180' },
        //  #endif
        { label: this.$t('PreoccupationManagement.form.category'), prop: 'skuQuantity', isCheck: true, disabled: false, width: '145'},
        { label: this.$t('PreoccupationManagement.form.number'), prop: 'goodsQuantity', isCheck: true, disabled: false, width: '121' },
        // #ifndef OPEN-SOURCE
        { label: this.$t('PreoccupationManagement.form.reserved'), prop: 'waitPreempCount', isCheck: true, disabled: false, width: '145' },
        { label: this.$t('PreoccupationManagement.form.succeeded'), prop: 'successCount', isCheck: true, disabled: false, width: '140' },
        { label: this.$t('PreoccupationManagement.form.failed'), prop: 'failureCount', isCheck: true, disabled: false, width: '135' },
        //  #endif
        { label: this.$t('PreoccupationManagement.form.store'), prop: 'storeName', isCheck: true, disabled: false, width: '115' },
        { label: this.$t('PreoccupationManagement.form.channel'), prop: 'channelTypeMeaning', isCheck: true, disabled: false, width: '105' },
        { label: this.$t('PreoccupationManagement.form.Three'), prop: 'orderTime', isCheck: true, disabled: false, width: '160' },
        { label: this.$t('PreoccupationManagement.form.order'), prop: 'creationDate', isCheck: true, disabled: false, width: '160'},
        { label: this.$t('PreoccupationManagement.form.time'), prop: 'predictDeliveryTime', isCheck: true, disabled: false, width: '180'},
        { label: this.$t('PreoccupationManagement.form.Operation'), prop: 'bjTableAction', isCheck: true, disabled: true, width: '180' },
      ],
    };
  },
  computed: {
    SCHL_CHANNEL_TYPE() {
      return this.$store.state.values.SCHL_CHANNEL_TYPE || [];
    },
  },
  watch: {
    queryParamsTime(v) {
      this.queryParams.orderStartTime = (v || [])[0];
      this.queryParams.orderEndTime = (v || [])[1];
    },
    queryParamsTime_create(v) {
      this.queryParams.creationDateStartTime = (v || [])[0];
      this.queryParams.creationDateEndTime = (v || [])[1];
    },
  },
  created() {},
  mounted() {
    this.$refs.BjPage.tableData = [
      {
        orderSn: 1111,
        innerOrderSn: 111,
      },
    ];
  },
  methods: {
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime = null;
      this.queryParamsTime_create = null;
      return new Promise(resolve => {
        resolve();
      });
    },
    /** 详情 */
    onDetail(row) {
      this.$toView('BusinessOrderPreemptView', row.id);
    },
  },
};
</script>
<style lang="scss" scoped>
  ::v-deep .bj-page .el-form-item__label {
    display: none;
  }
</style>
